import React, { useContext, useEffect } from 'react';

import _ from 'lodash';
import { ShopPage } from '../../src/app/ShopPage';
import { getTranslation } from '@lsoft/translate';
import PropTypes from 'prop-types';
import { schemaProduct } from '../../src/schema/schemaProduct';
import Head from 'next/head';
import { shopServerSideProps } from '../../src/tools/withShopPropsContext';
import { GTMProductList } from '../../src/container/shop/GTMProductList';
import { apply_mui_asset } from '@lsoft/shared/components/ui/NextAssetImage';
import { loadProduct } from '@lsoft/shared/container/Product';
import { ShopSingleProduct } from '../../src/components/Product/ShopSingleProduct';
import Grid from '@material-ui/core/Grid';
import { ShopProductContainer } from '../../src/container/shop/ShopProduct';
import { GroupTagsContainer } from '@lsoft/shared/container/pim/GroupTags';
import { apiGroupTagsRead } from '@lsoft/shared/api/group_tags';
import { usePathname } from 'next/navigation';
import { MuiAppContext } from '@lsoft/mui';

const ProductPage = ({
	SKU,
	productJsonLD,
	productData,
	grouptag_data,
	...pageProps
}) => {
	if (_.isNil(SKU)) return null;

	return (
		<ShopPage {...pageProps} noLogin variant={'sidebarMenu'}>
			<Head>
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify(productJsonLD, null, 2),
					}}
				/>
			</Head>
			<GTMProductList list={'single_product'} productDetailView>
				<ShopProductContainer sku={SKU} data={productData}>
					<Grid
						container
						direction={'row'}
						justifyContent={'center'}
						spacing={2}
					>
						<Grid item xs={12}>
							<GroupTagsContainer data={grouptag_data}>
								<ShopSingleProduct />
							</GroupTagsContainer>
						</Grid>
					</Grid>
				</ShopProductContainer>
			</GTMProductList>
		</ShopPage>
	);
};
ProductPage.propTypes = {
	SKU: PropTypes.number.isRequired,
	productJsonLD: PropTypes.object.isRequired,
};

export const getServerSideProps = shopServerSideProps(
	async ({ locale, query, origin }) => {
		const SKU = parseInt(query.SKU);
		const product = await loadProduct({
			sku: SKU,
		});

		const { name_text, short_text, mname, product_main_picture, group_tags } =
			product;
		const { data: group_tags_result } = await apiGroupTagsRead({
			uids: group_tags,
		});
		const productJsonLD = schemaProduct(product, locale, origin);

		const title = `${mname} ${getTranslation(name_text, locale)}`;
		const ogDescription = short_text;

		const ogImageUri = !_.isNil(product_main_picture)
			? apply_mui_asset(
					product_main_picture,
					{ width: 1200, height: 630, output_format: 'webp' },
					locale,
				).url
			: null;

		const gts = await group_tags_result;

		// const data = _.merge({}, product, { LOADED_GROUP_TAGS: loaded_group_tags });
		// TODO:
		// grouptags container  [tag1,tag2]    die nicht mit data übergeben werden,werden nachgeladen
		//
		// notwendig grouptags_get [tag1, tag2]  in pim_api

		return {
			props: {
				pageInfo: {
					title,
					ogDescription,
					ogImageUri,
				},
				SKU,
				productJsonLD,
				productData: product,
				grouptag_data: gts,
			},
		};
	},
);

export default ProductPage;
